import { render, staticRenderFns } from "./loadRailway.vue?vue&type=template&id=675dc5dc&scoped=true&"
import script from "./loadRailway.vue?vue&type=script&lang=js&"
export * from "./loadRailway.vue?vue&type=script&lang=js&"
import style0 from "./loadRailway.vue?vue&type=style&index=0&id=675dc5dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675dc5dc",
  null
  
)

export default component.exports